// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__2eEjr","desc":"Title_desc__2aFk6"};